import { sendHttpRequest } from "lib/fetcher";
import { IPSpeakerSearchDataType } from "lib/types";
import useWsSender from "lib/wsSenderHook";
import axios from "axios";
import { showToast } from "ui/components/common";

export type WsCameraSettingReq = {
  id: number;
  name: string;
  mainStream?: {
    bitRate: number;
    frameRate: number;
    resolution: {
      height: number;
      width: number;
      name: string;
    };
  };
  subStream?: {
    bitRate: number;
    frameRate: number;
    resolution: {
      height: number;
      width: number;
      name: string;
    };
  };
};
export function useCustomersService() {
  const { sendWsRequest } = useWsSender();
  // async function sendUpdateCameraNameRequest(
  //   cameras: { id: number; name: string }[],
  //   orgId,
  // ) {
  //   return sendWsRequest(
  //     "device.update_cameras_name",
  //     {
  //       deviceUpdateCamerasName: {
  //         data: cameras,
  //       },
  //     },
  //     { orgId },
  //   );
  // }
  async function upgradeEdge(orgId, id) {
    return sendWsRequest(
      "device.camera.upgrade_v2",
      {
        camUpgradeV2: {
          id: id,
          service: "camera_edge",
        },
      },
      { orgId: Number(orgId), timeout: 90000 },
    );
  }

  async function sendUpdateCameraSettingRequest(
    cameras: WsCameraSettingReq[],
    orgId,
  ) {
    return sendWsRequest(
      "device.update_cameras_settings",
      {
        deviceUpdateCamerasSettings: {
          data: cameras,
        },
      },
      { orgId, timeout: 35000 },
    );
  }

  async function sendSearchDeviceRequest(data, orgId) {
    return sendWsRequest(
      "device.search",
      {
        deviceSearch: data,
      },
      { orgId, timeout: 25000 },
    );
  }

  async function sendAddDeviceRequest(
    siteId: number,
    nvrId: number,
    data: IPSpeakerSearchDataType[],
    orgId,
  ) {
    return sendWsRequest(
      "device.speaker.add",
      {
        deviceSpeakerAdd: {
          siteId,
          nvrId,
          data,
        },
      },
      { orgId, timeout: 25000 },
    );
  }

  async function sendValidateDeviceRequest(data, orgId) {
    return sendWsRequest(
      "device.validate",
      {
        deviceValidate: {
          validateAccounts: [data],
        },
      },
      { orgId },
    );
  }

  return {
    sendUpdateCameraSettingRequest,
    sendSearchDeviceRequest,
    sendAddDeviceRequest,
    sendValidateDeviceRequest,
    upgradeEdge,
  };
}
export function getCamerasBySite(siteId, orgId) {
  return sendHttpRequest({
    url: "/camera/cameras?page.limit=300&siteId=" + siteId,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}
export function savePanoramaSettings(id, data, orgId) {
  return sendHttpRequest({
    url: `/site/sites/${id}/panorama_settings`,
    method: "patch",
    data: {
      data,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
}

export function getNvrsBySite(siteId, orgId) {
  return sendHttpRequest({
    url: `/device/nvrs?siteId=${siteId}&page.limit=600`,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}

export async function getEdgeCamerasBySite(siteId: number, orgId: string) {
  return sendHttpRequest({
    url: `/camera/cameras?siteIds=${siteId}&page.limit=600&isDev=true&withUp=true`,
    method: "get",
    headers: {
      "x-org-id": orgId,
    },
  });
}

export async function getEdgeCamerasAndNvrsBySite(
  orgId: string,
  siteId: number,
) {
  const results = await Promise.allSettled([
    getNvrsBySite(siteId, orgId),
    getEdgeCamerasBySite(siteId, orgId),
  ]);
  const data = { nvrs: [], edgeCameras: [] };
  results.forEach((result, index) => {
    if (result?.status !== "fulfilled") {
      return;
    }
    if (index === 0) {
      if (result.value?.status !== 200) {
        showToast(1, "There was a problem fetching NVRS. Please try again.");
      }
      console.log("result.value", result.value?.data?.data);
      data.nvrs = result.value?.data?.data || [];
    }
    if (index === 1) {
      if (result.value?.status !== 200) {
        showToast(
          1,
          "There was a problem fetching edge cameras. Please try again.",
        );
      }
      console.log("result.value", result.value?.data?.data);
      data.edgeCameras = result.value?.data?.data || [];
    }
  });
  return data;
}

export function claimEdgeCamera(siteId, macAddress, sn, orgId) {
  return sendHttpRequest({
    url: `/camera/cameras/claim`,
    method: "post",
    data: {
      siteId,
      macAddress,
      sn,
    },
    headers: {
      "x-org-id": orgId,
    },
  });
}

export function getTimezoneFromGoogleMapApi(lat, lng) {
  const apiKey = "AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg";
  const timestamp = Math.floor(new Date().getTime() / 1000);
  const instance = axios.create({
    baseURL: "https://maps.googleapis.com", // google map api url
    timeout: 5000,
  });
  return instance.get(
    `/maps/api/timezone/json?location=${lat}%2C${lng}&timestamp=${timestamp}&key=${apiKey}`,
  );
}
